import React, {
  createContext,
  useContext,
  useState,
} from "react";

const LoaderContext = createContext();

export const LoaderProvider = ({ children }) => {

  const [loading, setLoading] = useState(false);

  return (
    <LoaderContext.Provider
      value={{
        loading,
        setLoading,
      }}
    >
      {children}
    </LoaderContext.Provider>
  );
};

export const useLoader = () => {
  return useContext(LoaderContext);
};